import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const LeasingVyhodnoceni = lazy(() =>
  import('@/modules/leasing/LeasingVyhodnoceni').then((m) => ({
    default: m.LeasingVyhodnoceni,
  })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/leasing/$id/vyhodnoceni',
  component: () => (
    <Suspense fallback={null}>
      <LeasingVyhodnoceni />
    </Suspense>
  ),
});
